import { useState } from "react";
import { message } from "antd";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { AssistantAgentForm } from "./AssistantAgentForm";

function AssistantAgentEdit(props) {
  const { agent, updateAssistantAgent, open, onClose, assistantOptions } = props;
  const [loading, setLoading] = useState(false);

  const defaultAssistantAgent = {
    name: agent.name,
    assistantId: agent.assistantId,
    trigger: agent.trigger,
    dynamicWelcomeMessageEnabled: agent.dynamicWelcomeMessageEnabled ?? false,
  };

  const handleSubmit = (data) => {
    updateAssistantAgent(data)
      .then(() => {
        setLoading(false);
        onClose();
      })
      .catch(() => {
        message.error("Failed to update assistant agent");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {open && (
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>Edit Assistant Agent</DialogTitle>
          <DialogBody>
            <AssistantAgentForm
              defaultAssistantAgent={defaultAssistantAgent}
              assistantOptions={assistantOptions}
              onSubmit={handleSubmit}
              onCancel={onClose}
              loading={loading}
              setLoading={setLoading}
              buttonInfo={{
                buttons: "2",
                primaryLabel: "Save",
                secondaryLabel: "Cancel",
              }}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export { AssistantAgentEdit };
